import { Route } from '@angular/router';
import { LOCALIZED_SHARED_ROUTES, SHARED_ROUTE_IDS } from '../shared-route-const';

/** The tabs of Mein Profil, in the order the page shows them. */
const MEIN_PROFIL_TAB_ROUTE_IDS = [
  SHARED_ROUTE_IDS.PROFILE_PERSONAL,
  SHARED_ROUTE_IDS.PROFILE_PASSWORD,
  SHARED_ROUTE_IDS.PROFILE_NOTIFICATIONS,
] as const;

/**
 * The «Mein Profil» route with one child per tab, identical in both apps.
 *
 * Each child loads the same page component and names itself through `routeId`, which is how the
 * page knows which tab is open. The empty path redirects to the first tab.
 *
 * @param {string} locale - The language of the bundle being built.
 * @param {Route['canActivate']} guards - What guards the route, applied to the parent and its children.
 * @returns {Route} The route to put into the app's route list.
 */
export function buildMeinProfilRoute(locale: string, guards: Route['canActivate']): Route {
  return {
    path: LOCALIZED_SHARED_ROUTES[SHARED_ROUTE_IDS.PROFILE][locale],
    canActivate: guards,
    canActivateChild: guards,
    data: { routeId: SHARED_ROUTE_IDS.PROFILE },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: LOCALIZED_SHARED_ROUTES[SHARED_ROUTE_IDS.PROFILE_PERSONAL][locale], // Default tab
      },
      ...MEIN_PROFIL_TAB_ROUTE_IDS.map(
        (routeId): Route => ({
          path: LOCALIZED_SHARED_ROUTES[routeId][locale],
          loadComponent: () =>
            import('../features/mein-profil/mein-profil-page/mein-profil-page.component').then((m) => m.MeinProfilPageComponent),
          data: { routeId },
        }),
      ),
    ],
  };
}
